import { Field, Formik } from 'formik'
import * as Yup from 'yup'
import {
  InputField,
  transformErrorForForm,
} from './form'
import { BaseRegista, Fonte } from '../types'

const FonteSchema = Yup.object().shape({
  nome: Yup.string().required().label('Nome'),
})

interface Props {
  fonte?: Fonte
  save: (fonte: Fonte) => Promise<unknown>
}

export const initialThemeValues: BaseRegista = {
  nome: '',
}

export default function FonteForm({ fonte, save }: Props) {
  return (
    <Formik
      enableReinitialize
      onSubmit={(regista, { setErrors }) =>
        save(regista).catch((error) => {
          setErrors(transformErrorForForm(error))
        })
      }
      validationSchema={FonteSchema}
      initialValues={(fonte ?? initialThemeValues) as Fonte}
    >
      {({ handleSubmit, isSubmitting, isValid, values }) => (
        <form onSubmit={handleSubmit} className="hm-form">
          <div className="row">
            <div className="col-md-12">
              <Field
                required
                label={`Nome`}
                name={`nome`}
                component={InputField}
              />
            </div>
          </div>
          <div className="d-flex justify-content-end">
            <button
              type="submit"
              disabled={isSubmitting || !isValid}
              className="btn btn-success"
            >
              <i className="text-white me-1 bi bi-save-fill"></i> Salva
            </button>
          </div>
        </form>
      )}
    </Formik>
  )
}
